export default __webpack_public_path__ + "static/media/Saly.e888b0e0.png";